import { createPaywallApi } from '@forest/paywall-core'
import { userInfoSource } from '~/store/user-info'

/** Cluster-routed forest-api client; base URL follows `UserInfo.server`. */
export const api = createPaywallApi({ userInfo: userInfoSource })
